import React, { useCallback, useState } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import styledComponents from 'styled-components'
import { IconButton } from '@mui/material'
import AddBoxIcon from '@mui/icons-material/AddBox'
import DeleteIcon from '@mui/icons-material/Delete';
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import useLanguages from '../hooks/useLanguages'

const InputsContainer = styledComponents.div`
  display: flex;
  margin-top: 10px;
  gap: 12px;
  margin-bottom: 16px;
`

const languageRowStyle = { '&:last-child td, &:last-child th': { border: 0 } }

const LanguagesConfig = ({ isOpen, onClose }) => {
  const [language, setLanguage] = useState('')
  const [code, setCode] = useState('')
  const [languages, languagesJson] = useLanguages()

  const handleAddNewLanguage = useCallback(() => {
    languages?.push([{
      language,
      code,
    }])

    setLanguage('')
    setCode('')
  }, [code, language, languages])

  const handleDeleteLanguage = useCallback((index) => {
    languages?.delete(index)
  }, [languages])

  const handleClose = useCallback((_, reason) => {
    if (reason !== 'backdropClick') {
      onClose()
    }
  }, [onClose])

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Language Settings</DialogTitle>
      <DialogContent>
        <InputsContainer>
          <TextField
            autoFocus
            margin="none"
            id="language"
            label="Language"
            type="text"
            fullWidth
            variant="outlined"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            placeholder='English'
          />
          <TextField
            autoFocus
            margin="none"
            id="code"
            label="Code"
            type="text"
            fullWidth
            variant="outlined"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder='en'
          />
          <IconButton aria-label="add" onClick={handleAddNewLanguage}>
            <AddBoxIcon />
          </IconButton>
        </InputsContainer>
        {languagesJson && languagesJson.length > 0 && (
          <TableContainer component={Paper}>
            <Table aria-label="language table">
              <TableHead>
                <TableRow>
                  <TableCell>Language</TableCell>
                  <TableCell>Code</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {languagesJson?.map((row, i) => (
                  <TableRow
                    key={i}
                    sx={languageRowStyle}
                  >
                    <TableCell>{row.language}</TableCell>
                    <TableCell>{row.code}</TableCell>
                    <TableCell>
                      <IconButton aria-label="delete" onClick={() => handleDeleteLanguage(i)}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default LanguagesConfig